/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import useTableState from "hooks/useTableState";
import useGetPerPage from "hooks/useGetPerPage";
import SkeletonCell from "tables/common/SkeletonCell";
import TableUI from "tables/common/TableUI";

export default function TableWithSkeleton({
  data,
  columns,
  isFetching,
  isLoading,
  meta,
  enableRowSelection,
  getRowId,
  isWhite,
  isCustomScroll,
}) {
  const length = useGetPerPage(10);
  const tableState = useTableState({
    length,
    columns,
    data,
    isLoading,
    cell: <SkeletonCell />,
  });

  const { getHeaderGroups, getRowModel, getCenterTotalSize } = useReactTable({
    data: tableState.data,
    columns: tableState.columns,
    getCoreRowModel: getCoreRowModel(),
    meta,
    enableRowSelection,
    getRowId,
  });

  const isDataUpdating = !isLoading && isFetching;

  return (
    <TableUI
      isWhite={isWhite}
      isCustomScroll={isCustomScroll}
      getCenterTotalSize={getCenterTotalSize}
      getHeaderGroups={getHeaderGroups}
      getRowModel={getRowModel}
      isDataUpdating={isDataUpdating}
    />
  );
}

TableWithSkeleton.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetching: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isWhite: PropTypes.bool,
  isCustomScroll: PropTypes.bool,
  meta: PropTypes.shape({}),
  enableRowSelection: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  getRowId: PropTypes.func,
};
